var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"docs"}},[(_vm.doc_text_html)?_c('div',{staticClass:"ma-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.doc_text_html)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }